import { render, staticRenderFns } from "./ClassFileUploader.vue?vue&type=template&id=98247eba&scoped=true&"
import script from "./ClassFileUploader.vue?vue&type=script&lang=js&"
export * from "./ClassFileUploader.vue?vue&type=script&lang=js&"
import style0 from "./ClassFileUploader.vue?vue&type=style&index=0&id=98247eba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98247eba",
  null
  
)

export default component.exports